import schoolmanagementapi from "./devapis/schoolmanagementapi";
import contentmanagementapi from "./devapis/contentmanagementapi"
import taskapi from "./devapis/taskapi";
import eventApi from "./devapis/eventapi";
import attendanceapis from "./devapis/attendanceapis";
import b2capis from "./devapis/b2capis";
import configureassessmentapi from "./devapis/configureassessmentapi";
import mastercategoryapi from "./devapis/mastercategoryapi";
import issuecategoryapi from "./devapis/issuecategoryapi";
import careerapi from "./devapis/careerapi";
export const devapis = {
  ...schoolmanagementapi,
  ...contentmanagementapi,
  ...taskapi,
  ...eventApi,
  ...attendanceapis,
  ...b2capis,
  ...configureassessmentapi,
  ...mastercategoryapi,
  ...issuecategoryapi,
  ...careerapi,

  login: {
    url: "/api/v1/auth/login",
    method: "post",
  },
  refreshToken: {
    url: "/api/v1/auth/refresh",
    method: "post",
  },
  forgetpassword: {
    url: "/api/v1/auth/forget",
    method: "post",
  },
  resetStudentPassword: {
    url: "/api/v1/auth/student_forget",
    method: "post",
  },
  resetMultipleStudentsPassword: {
    url: "/api/v1/auth/multiple_student_forget/{school_id}",
    method: "post",
  },
  changepassword: {
    url: "/api/v1/auth/password",
    method: "put",
  },

  getDashboardBarChartData: {
    url: "/api/v2/dashboard/school_progress/{school_id}",
    method: "get",
  },
  getSessionProgressBarChart: {
    url: "/api/v2/dashboard/session_progress/?month={month}&year={year}&school_id={school_id}&class_id={class_id}&module_id={module_id}",
    method: "get",
  },
  getMonthlyEventProgress: {
    url: "/api/v2/event/graph/?month={month}&year={year}&school_id={school_id}&curriculum_id={curriculum_id}&section_id={section_id}&type={type}&start_date={start_date}&end_date={end_date}",
    method: "get",
  },
  getDashboard: {
    url: "/api/v2/dashboard/?school_id={school_id}",
    method: "get",
  },
  getEventDashboard: {
    url: "/api/v2/event/dashoard",
    method: "get",
  },
  getEventReportPdf: {
    url: "/api/v2/event/report/pdf",
    method: "get",
  },
  getEventReportExcel: {
    url: "/api/v2/event/download/excel",
    method: "get",
  },
  otpLogin: {
    url: "/api/v1/auth/otp/{mobile_num}",
    method: "get",
  },
  otpLoginVerify: {
    url: "/api/v1/auth/verify",
    method: "post",
  },
  downloadFile: {
    url: `/api/v1/download-documents`,
    method: "post",
  },
  // PROFILES
  createProfile: {
    url: "/api/v1/profile",
    method: "post",
  },
  getProfile: {
    url: "/api/v1/profile",
    method: "get",
  },
  getUser: {
    url: "/api/v1/profile/me",
    method: "get",
  },
  getProfileById: {
    url: "/api/v1/profile/{profile_id}",
    method: "get",
  },
  updateProfileById: {
    url: "/api/v1/profile/{profile_id}",
    method: "put",
  },
  deleteProfile: {
    url: "/api/v1/profile/{profile_id}",
    method: "delete",
  },
};

export default devapis;